import { Record } from 'immutable';

export const defaultLanguageData: LanguageType = {
  code: '',
  translationKey: '',
};

export interface LanguageType {
  code: string;
  translationKey: string;
}

export interface AvailableLanguage {
  code: string;
  name: string;
}

export default class LanguageRecord extends Record<LanguageType>(defaultLanguageData) {}
